module.exports = __webpack_public_path__ + "img/right1.8f0c7494.png";